<div>
    <div *ngFor="let item of dataPartial; index as i">
        <!--<div class="multi-level-item" [ngClass]="{'multi-level-item-toogle':item.target.entityTypeId != 4 ,'multi-level-item-disabled':item.target.entityTypeId != 4 && !item.childs!.length}">
            <input [hidden]="item.target.entityTypeId != 4 && !item.childs!.length" id="entity-multilevel-item-{{ i }}" type="checkbox" [(ngModel)]="item.selected" 
            (change)="change($event)"/>
            <span (click)="toogle(item)">{{item.target.name}}</span>
        </div>-->
        <div [hidden]="!item.visible"
            [className]="'multi-level-item multi-level-item-'+item.target.entityTypeId + (item.target.entityTypeId != 4 ? ' multi-level-item-toogle':'') + ' multi-level-item-toogle-'+(item.opened ? 'opened' : 'closed')+(item!.selected && item.target.entityTypeId == 4 ? ' multi-level-item-selected' : '')">
            <div (click)="toogle(item)">
                <span>{{item.target.name}}</span>
            </div>
            <input *ngIf="!allSelected" id="entity-multilevel-item-{{ i }}" type="checkbox" [(ngModel)]="item.selected"
                (change)="change($event,item)" />

        </div>
        <div *ngIf="item.opened"
            [className]="'multi-level-item-container  multi-level-item-container-'+item.target.entityTypeId">
            <hbo-multi-select-multi-level-item [search]="search" [typeData]="typeData"
                [item]="item" [data]="item.childs" [selected]="item.selected"
                (callback)="setShops($event)" (callbackVisible)="visibleEntity($event)"></hbo-multi-select-multi-level-item>
        </div>
    </div>
</div>